import axios, { AxiosInstance } from "axios";

const API_BASE_URL = import.meta.env.VITE_API_URL
  ? import.meta.env.VITE_API_URL
  : import.meta.env.VITE_API_GATEWAY_URL
  ? `${import.meta.env.VITE_API_GATEWAY_URL.replace(/\/\/+$/, "")}/api`
  : "http://localhost:8000/api";
const CITY_HEADS_BASE_URL = `${API_BASE_URL.replace(/\/\/+$/, "")}/v1/city-heads`;

export interface CityHead {
  id: string;
  employeeId: string;
  name: string;
  phoneNumber: string;
  emailId: string;
  city: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface CreateCityHeadRequest {
  employeeId: string;
  name: string;
  phoneNumber: string;
  emailId: string;
  city: string;
}

export interface UpdateCityHeadRequest {
  employeeId?: string;
  name?: string;
  phoneNumber?: string;
  emailId?: string;
  city?: string;
}

const cityHeadApi: AxiosInstance = axios.create({
  baseURL: CITY_HEADS_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

cityHeadApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("authToken");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

cityHeadApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.warn("CityHead service request unauthorized:", error.config?.url);
    }
    return Promise.reject(error);
  }
);

class CityHeadService {
  async getCityHeads(params?: { search?: string; page?: number; limit?: number }) {
    const response = await cityHeadApi.get("/", { params });
    return response.data;
  }

  async getCityHeadById(id: string) {
    const response = await cityHeadApi.get(`/${encodeURIComponent(id)}`);
    return response.data;
  }

  async createCityHead(payload: CreateCityHeadRequest) {
    const response = await cityHeadApi.post("/", payload);
    return response.data;
  }

  async updateCityHead(id: string, payload: UpdateCityHeadRequest) {
    const response = await cityHeadApi.put(`/${encodeURIComponent(id)}`, payload);
    return response.data;
  }

  async deleteCityHead(id: string) {
    const response = await cityHeadApi.delete(`/${encodeURIComponent(id)}`);
    return response.data;
  }
}

export const cityHeadService = new CityHeadService();
export default cityHeadService;
